import { createAsyncThunk } from "@reduxjs/toolkit";
import { type LinkCandidate } from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listLinkCandidates = createAsyncThunk<
  LinkCandidate[],
  { referralId: string; q?: string },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(
  thunkTypes.LIST_LINK_CANDIDATES,
  async ({ referralId, q }, { extra }) => {
    return await extra.referralsBackofficeRepo.linkCandidates(
      referralId,
      q,
    );
  },
);
